module.exports = __webpack_public_path__ + "static/package-4a7fc3a0fc7b40c6340559eb3c43e313.png";